import JSZip from 'jszip'
import { saveAs } from 'file-saver'

export default (ctx, inject) => {
	inject('multipleDownloadAsZip', async (urls = [], filename = 'files.zip') => {
		const zip = new JSZip()

		// Download each file and add to zip
		for (const file of urls) {
			const url = file.url
			const response = await fetch(url)
			const blob = await response.blob()
			zip.file(file.filename || url.replace(/^.*[\\/]/, ''), blob)
		}

		// Generate ZIP and download
		const content = await zip.generateAsync({ type: 'blob' })
		saveAs(content, filename)
	})
}
